import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import React, { useState } from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';
import { validate as reportingValidate } from '@finley-technologies/reporting-utilities';

import { AddIconButton } from '../../../../../../common-frontend/components/IconButton';
import { CreditAgreementFullArtifactWipConfigType } from '../../../../types';
import { getIterationKey } from '../../../common';
import { AddConfigModal } from './ReportingOutputDocxAddConfigModal';
import { ReportingOutputDocxFileInsertionOutput } from './ReportingOutputDocxFileInsertionOutput';

type ReportingOutputDocxFileInsertionOutputContainerProps = {
  organizationId: string;
  fileInsertionOutputs?: CreditAgreement.Config.Reporting.Outputs.Docx.FileInsertionOutput[];
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
  basePropertyKey: string;
};
export const ReportingOutputDocxFileInsertionOutputContainer = ({
  organizationId,
  fileInsertionOutputs = [],
  wipConfig,
  basePropertyKey,
}: ReportingOutputDocxFileInsertionOutputContainerProps) => {
  const [isAddConfigModalOpen, setIsAddConfigModalOpen] = useState<boolean>(
    false,
  );

  return (
    <Box
      id="reporting-output-docx-file-insertion-output-container"
      mb="4"
      borderWidth="1px"
      p="4"
    >
      <Flex mb="5" alignItems="center">
        <Heading fontSize="large" as="h4" mr="3">
          File Insertion Outputs
        </Heading>

        {wipConfig?.isMutateAllowed(basePropertyKey) && (
          <>
            <AddIconButton
              ariaLabel="add file insertion output"
              label="Add File Insertion Output"
              onClick={() => {
                setIsAddConfigModalOpen(true);
              }}
            />
            <AddConfigModal
              basePropertyKey={basePropertyKey}
              isOpen={isAddConfigModalOpen}
              setIsOpen={setIsAddConfigModalOpen}
              wipConfig={wipConfig}
            />
          </>
        )}
      </Flex>

      {fileInsertionOutputs.length > 0 ? (
        <>
          {fileInsertionOutputs.map((output, idx) => {
            const id = getIterationKey(output);
            return (
              <ReportingOutputDocxFileInsertionOutput
                key={id}
                fileInsertionOutput={output}
                existingFileInsertionOutputs={fileInsertionOutputs}
                basePropertyKey={basePropertyKey}
                organizationId={organizationId}
                wipConfig={wipConfig}
                validationVariables={
                  reportingValidate.util.SUPPLEMENTAL_QUERY_VARIABLES
                }
                idx={idx}
              />
            );
          })}
        </>
      ) : (
        <Text>No file insertion outputs currently configured.</Text>
      )}
    </Box>
  );
};
